<template>
  <div class="o-tip">
    <!-- 组件：遮罩 -->
    <transition
      name="dialog-mask-transition"
      enter-active-class="animated fadeIn"
    >
      <div
        id="J_mask"
        class="c-mask"
        v-if="tip.isActive"
        @click.prevent="hideTip"
      ></div>
    </transition>
    <transition
      name="dialog-mask-transition"
      enter-active-class="animated fadeIn"
    >
      <div class="c-tip-pop" v-if="tip.isActive">
        <i class="c-tip-pop_close" @click.prevent="hideTip"></i>
        <h3 class="c-tip-pop_title">日理萬姬儲值提示</h3>
        <div class="c-tip-pop_main">
          <p class="c-tip-pop_ctn">{{ tip.txt }}</p>
        </div>
        <p class="c-tip-pop_btn-box">
          <button class="c-tip-pop_btn" @click.prevent="hideTip">確認</button>
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'tips-vue',
  props: {
    tip: {
      type: Object,
      require: true,
    },
  },
  methods: {
    hideTip() {
      // this.tip.isActive = false;
      // this.tip.txt = '';
      this.resetTips();
      typeof this.tip.call == 'function' && this.tip.call();
      this.tip.call = null;
    },
    ...mapMutations(['resetTips']),
  },
};
</script>
